import { FaFileContract, FaFileSignature, FaFileAlt } from "react-icons/fa";

// Downloadable templates for innovators. Adding a new document is one entry
// here plus the file dropped into public/documents/.
// Icons are placeholders until the client sends their own artwork.
export const documents = [
  {
    name: "MOU Template",
    description:
      "Memorandum of Understanding template for agreements between two parties.",
    file: "/documents/mou-template.docx",
    icon: FaFileContract,
  },
  {
    name: "NDA Template",
    description:
      "Non-Disclosure Agreement template for protecting confidential information.",
    file: "/documents/nda-template.docx",
    icon: FaFileSignature,
  },
  {
    name: "Work Order Template",
    description:
      "Work Order template for confirming an accepted quotation and scope of work.",
    file: "/documents/work-order-template.docx",
    icon: FaFileAlt,
  },
];
